import { cn } from "@/modules/lib/utils"
import { ProfilRequestIcon } from "@images/svgIcons/profilRequestIcon"
import { word } from "@modules/core/utils/i18n"
import { useProgramSasRequestTotal } from "@modules/programs/programSas/hooks/useProgramSasRequestTotal"
import { ChevronRight, Dot } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"

type ProgramSasPendingSubscribersProps = {
  programId: string
  displaySASRequestToAcceptView: () => void
  className?: string
} & React.ComponentProps<"div">

export function ProgramInfoSasPendingSubscribers({
  programId,
  displaySASRequestToAcceptView,
  className,
  ...props
}: ProgramSasPendingSubscribersProps) {
  const { data: sasRequestTotal } = useProgramSasRequestTotal(programId)

  return (
    <div
      className={cn("mb-4 flex cursor-pointer items-center justify-between", className)}
      onClick={() => {
        displaySASRequestToAcceptView()
      }}
      {...props}
    >
      <div className="flex items-center">
        <ProfilRequestIcon color={"black"} />
        <div className="ml-2 flex flex-col">
          <Text fontStyle="TS">{word("program.sas.list.header.title")}</Text>
          <Text fontStyle="BS">{word("program.sas.list.title", { count: sasRequestTotal.allPending })}</Text>
        </div>
      </div>
      <div className="mr-4 flex items-center">
        <Dot color={"currentColor"} strokeWidth={6} className="text-textError" />
        <ChevronRight color={"currentColor"} size={20} strokeWidth={2} className="text-textDefault-body" />
      </div>
    </div>
  )
}
